import React from "react";
import { GeoJSON, Marker, Popup } from "react-leaflet";
import { Button } from "@material-ui/core";
import L from "leaflet";
import { NavLink } from "react-router-dom";
import iconUrl from "../image/pin24.png";
import educationUrl from "../image/education.png";
import officeUrl from "../image/office.png";
import industriesUrl from "../image/industries.png";
import infrastructureUrl from "../image/infrastructure.png";
import workshopUrl from "../image/workshop.png";
import agricultureUrl from "../image/agriculture.png";
import homestayUrl from "../image/homestay.png";
import economicUrl from "../image/economic.png";
import healthUrl from "../image/health.png";
import { BASE_URL, baseURLAPI } from "../../redux/axiosHandler";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import { popup } from "../../variable/mapPointerPopup";

export default function GeoJsonLayer(props) {
	const institutePopUp = (properties) => {
		if (!properties.parentCategory) {
            const baseImageUrl = `${baseURLAPI}/imageUpload/image/${properties.id}_house.jpg`;
            return (
                <div>
                    <img
                        src={baseImageUrl}
                        alt={properties.houseNumer}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>House Number:</b> {properties.houseNumber}
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>Owner Name:</b> {properties.ownerName}
                    <br />
                    <b>Tole Name:</b> {properties.toleName}
                    <br />
                    {properties.contactNumber && (
                        <span>
                            <b>Contact:</b> {properties.contactNumber}
                        </span>
                    )}{" "}
                    <br />
                    <NavLink
                        className="menu-link menu-toggle"
                        to={`/home-survey/detail/${properties.id}`}
                        target="_blank"
                    >
                        <Button variant="info">View Detail</Button>
                    </NavLink>
                </div>
            );
        } else if (properties.name && properties.bankClass) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.name}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Name:</b> {properties.name}
                    <br />
                    <b>Bank Class:</b> {properties.bankClass}
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else if (properties.name && properties.bridgeType) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.name}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Name:</b> {properties.name}
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>River Name:</b> {properties.riverName}
                    <br />
                    <b>Bridge Height:</b> {properties.bridgeHeight}
                    <br />
                    <b>Bridge Type:</b> {properties.bridgeType}
                    <br />
                    <b>Status:</b> {properties.status}
                    <br />
                    <b>Established At:</b> {properties.establishedAt}
                    <br />
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else if (properties.name && properties.proprietorInfo) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.name}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Name:</b> {properties.name}
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>Business Type:</b> {properties.businessType.map((key, value)=>{
						return value+', ';
					})}
                    <br />
                    <b>Street Name:</b> {properties.streetName}
                    <br />
                    <b>Established Year:</b> {properties.establishedYear}
                    <br />
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else if (properties.name && properties.historyDetail) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.name}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Name:</b> {properties.name}
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>History Detail:</b> {properties.historyDetail}
                    <br />
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else if (properties.name && properties.principalName) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.name}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Name:</b> {properties.name}
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>Institute Type:</b> {properties.instituteType}
                    <br />
                    <b>Institute Level:</b> {properties.instituteLevel}
                    <br />
                    <b>Established Year:</b> {properties.establishedYear}
                    <br />
                    <b>Principal Name:</b> {properties.principalName}
                    <br />
                    <b>Contact Number:</b> {properties.contactNumber}
                    <br />
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else if (properties.name && properties.governmentOfficeType) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.name}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Name:</b> {properties.name}
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>Government Office Type:</b>{" "}
                    {properties.governmentOfficeType}
                    <br />
                    <b>Office Head Name:</b> {properties.officeHeadName}
                    <br />
                    <b>Information Officer Name:</b>{" "}
                    {properties.informationOfficerName}
                    <br />
                    <b>Office Contact:</b> {properties.officeContact}
                    <br />
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else if (properties.name && properties.healthOrgType) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.name}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Name:</b> {properties.name}
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>Health Organization Type:</b> {properties.healthOrgType}
                    <br />
                    <b>Institute Type:</b> {properties.instituteType}
                    <br />
                    <b>Sponsor Name:</b> {properties.orgSponsorName}
                    <br />
                    <b>Contact Number:</b> {properties.orgContactNumber}
                    <br />
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else if (properties.name && properties.historicalLegend) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.name}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Name:</b> {properties.name}
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>Established Date:</b> {properties?.establishedDate}
                    <br />
                    <b>Sub Category:</b> {properties.subCategory}
                    <br />
                    <b>Historical Legend:</b> {properties.historicalLegend}
                    <br />
                    <b>Sponsor Person Name:</b>{" "}
                    {properties.sponsorPersonInfo?.name}
                    <br />
                    <b>Sponsor Person Contact Number:</b>{" "}
                    {properties.sponsorPersonInfo?.contactNumber}
                    <br />
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else if (properties.name && properties.productionGoodsName) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.name}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Name:</b> {properties.name}
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>Industry Category:</b> {properties.industryCategory}
                    <br />
                    <b>Director Name:</b> {properties.directorName}
                    <br />
                    <b>Production Goods Name:</b>{" "}
                    {properties.productionGoodsName}
                    <br />
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else if (properties.name && properties.institutionsType) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.name}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Name:</b> {properties.name}
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>Institution Type:</b> {properties.institutionsType}
                    <br />
                    <b>Office Head Name:</b> {properties.officeHeadName}
                    <br />
                    <b>Office Contact:</b> {properties.officeContact}
                    <br />
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else if (properties.name && properties.otherName) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.name}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Name:</b> {properties.name}
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>Other Name:</b> {properties.otherName}
                    <br />
                    <b>Description:</b> {properties.description}
                    <br />
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else if (properties.name && properties.numberOfVisitor) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.name}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Name:</b> {properties.name}
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>Park Speciality:</b> {properties.parkSpeciality}
                    <br />
                    <b>Number Of Visitor:</b> {properties.numberOfVisitor}
                    <br />
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else if (properties.presidentName) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.name}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>Address:</b> {properties.address}
                    <br />
                    <b>President Name:</b> {properties.presidentName}
                    <br />
                    <b>Office Contact Number:</b>{" "}
                    {properties.officeContactNumber}
                    <br />
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else if (properties.name && properties.condition) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.name}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Name:</b> {properties.name}
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>President Name:</b> {properties.presidentInfo.name}
                    <br />
                    <b>President Contact Number:</b>{" "}
                    {properties.presidentInfo.contactNumber}
                    <br />
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else if (properties.bankName) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.bankName}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Name:</b> {properties.bankName}
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else if (properties.streetName && properties.busStationName) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.streetName}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Street Name:</b> {properties.streetName}
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>Bus Station Name:</b> {properties.busStationName}
                    <br />
                    <b>Sub Category:</b> {properties.subCategory}
                    <br />
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else if (properties.name && properties.buildingUse) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.name}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Name:</b> {properties.name}
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>Building Ownership:</b> {properties.buildingOwnership}
                    <br />
                    <b>Building Use:</b> {properties.buildingUse}
                    <br />
                    <b>President Name:</b> {properties.presidentInfo.name}
                    <br />
                    <b>President Contact Number:</b>{" "}
                    {properties.presidentInfo.contactNumber}
                    <br />
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else if (properties.name && properties.groupType) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.name}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Name:</b> {properties.name}
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>Group Type:</b> {properties.groupType}
                    <br />
                    <b>chairman Name:</b> {properties.chairmanInfo.name}
                    <br />
                    <b>chairman Contact Number:</b>{" "}
                    {properties.chairmanInfo.contactNumber}
                    <br />
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else if (properties.electricSabhdaha) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.name}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>Address:</b> {properties.address}
                    <br />
					<b>Electric Sabh Daha:</b> {properties.electricSabhdaha}
                    <br />
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else if (properties.name && properties.culvertLength) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.name}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Name:</b> {properties.name}
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>Sub Category:</b> {properties.subCategory}
                    <br />
                    <b>Culvert Length:</b> {properties.culvertLength}
                    <br />
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else if (properties.tankCapacity) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.name}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>Address:</b> {properties.address}
                    <br />
                    <b>Resource Person Contact:</b>{" "}
                    {properties.resourcePersonContact}
                    <br />
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else if (properties.name && properties.electricityType) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.name}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Name:</b> {properties.name}
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>Electricity Type:</b> {properties.electricityType}
                    <br />
                    <b>Capacity:</b> {properties.capacity}
                    <br />
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else if (properties.name && properties.newspaperType) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.name}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Name:</b> {properties.name}
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>FM Range:</b> {properties.fmRange}
                    <br />
                    <b>President Name:</b> {properties.presidentInfo.name}
                    <br />
                    <b>President Contact Number:</b>{" "}
                    {properties.presidentInfo.contactNumber}
                    <br />
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else if (properties.address && properties.helper) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.address}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>Address:</b> {properties.address}
                    <br />
                    <b>Helper:</b> {properties.helper}
                    <br />
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else if (properties.ownership && properties.use) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.Ownership}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>Address:</b> {properties.address}
                    <br />
                    <b>use:</b> {properties.use}
                    <br />
                    <b>Ownership:</b> {properties.ownership}
                    <br />
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else if (properties.name && properties.areaAndCapacity) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.name}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Name:</b> {properties.name}
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else if (properties.name && properties.purpose) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.name}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Name:</b> {properties.name}
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>Sub Category:</b> {properties.subCategory}
                    <br />
                    <b>Purpose:</b> {properties.purpose}
                    <br />
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else if (properties.name && properties.disasterType) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.name}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>Disaster Type:</b> {properties.disasterType}
                    <br />
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else if (properties.organizationName) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.name}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>Address</b> {properties.address}
                    <br />
                    <b>subCategory:</b> {properties.subCategory}
                    <br />
                    <b>Organization Name:</b> {properties.organizationName}
                    <br />
                    <b>Street Name</b> {properties.streetName}
                    <br />
                    <b>managerContactNumber</b>{" "}
                    {properties.managerContactNumber}
                    <br />
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else if (properties.name && properties.securityType) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.name}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Name:</b> {properties.name}
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>Security Type:</b> {properties.securityType}
                    <br />
                    <b>Area Of Work</b> {properties.areaOfWork}
                    <br />
                    <br />
                    <b>Office Head Name</b> {properties.officeHeadName}
                    <br />
                    <b>Contact Number</b> {properties.contactNumber}
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else if (properties.toleName && properties.dailySlaughterCount) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.toleName}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Tole Name:</b> {properties.toleName}
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>Address:</b>
                    {properties.address}
                    <br />
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else if (properties.name && properties.marketDistance) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.name}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Name:</b> {properties.name}
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>ownership:</b> {properties.ownership}
                    <br />
                    <b>Description:</b> {properties.description}
                    <br />
                    <b>Resource Person Name:</b>{" "}
                    {properties.resourcePersonInfo?.name}
                    <br />
                    <b>Resource Person Contact Number:</b>
                    {properties.resourcePersonInfo?.contactNumber}
                    <br />
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else if (properties.networkRange && properties.towerType) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.networkRange}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>towerType:</b> {properties.towerType}
                    <br />
                    <b>networkRange:</b> {properties.networkRange}
                    <br />
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else if (properties.name && properties.resourceType) {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.image}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.name}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Name:</b> {properties.name}
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>Characteristic:</b> {properties.characteristic}
                    <br />
                    <b>Resource Type:</b>
                    {properties.resourceType}
                    <br />
                    <b>Conservation Body And Contact:</b>
                    {properties.conservationBodyAndContact}
                    <br />
                    <b>Google Plus Code:</b>{" "}
                    <a
                        href={`https://plus.codes/${properties.googlePlusCode}`}
                        target="_blank"
                    >
                        {properties.googlePlusCode}
                    </a>
                </div>
            );
        } else {
            const baseUrl = `${BASE_URL}/api/imageUpload/instituteImage/${properties.photo}`;
            return (
                <div>
                    <img
                        src={baseUrl}
                        alt={properties.name}
                        width={300}
                        height={200}
                        style={{ objectFit: "cover" }}
                        onError={(event) => {
                            event.target.src = toAbsoluteUrl(
                                "/media/image/NoImageFound.jpg"
                            );
                            event.onerror = null;
                        }}
                    />
                    <br />
                    <br />
                    <b>Office Name:</b> {properties.name}
                    <br />
                    <b>Ward Number:</b> {properties.wardNumber}
                    <br />
                    <b>Institution Type:</b> {properties.institutionsType}
                    <br />
                </div>
            );
        }
	};

	return props.objPoint.features.map((eachFeature) => {
		if (eachFeature.geometry.type === "Point") {
			const properties = eachFeature.properties;
			const eachCoordinates = eachFeature.geometry.coordinates;
			var pointerIcon = L.Icon.extend({
				options: {
					iconAnchor: [12, 24],
				},
			});

			var icon;
			if (properties.institutionsType === "education") {
				icon = new pointerIcon({
					iconUrl: educationUrl,
				});
			} else if (
				properties.institutionsType === "gov_office" ||
				properties.institutionsType === "offices" ||
				properties.institutionsType === "palika_related_office"
			) {
				icon = new pointerIcon({ iconUrl: officeUrl });
			} else if (properties.institutionsType === "industries") {
				icon = new pointerIcon({ iconUrl: industriesUrl });
			} else if (properties.institutionsType === "education") {
				icon = new pointerIcon({ iconUrl: agricultureUrl });
			} else if (properties.institutionsType === "economic") {
				icon = new pointerIcon({ iconUrl: economicUrl });
			} else if (properties.institutionsType === "forest") {
				icon = new pointerIcon({ iconUrl: homestayUrl });
			} else if (properties.institutionsType === "cultural_heritage") {
				icon = new pointerIcon({ iconUrl: workshopUrl });
			} else if (
				properties.institutionsType === "health" ||
				properties.institutionsType === "public_places"
			) {
				icon = new pointerIcon({ iconUrl: healthUrl });
			} else if (properties.institutionsType === "infrastructure") {
				icon = new pointerIcon({ iconUrl: infrastructureUrl });
			} else {
				icon = new pointerIcon({ iconUrl: iconUrl });
			}

			return (
				<Marker position={[eachCoordinates[1], eachCoordinates[0]]} icon={icon}>
					<Popup>{institutePopUp(properties)}</Popup>
				</Marker>
			);
		}
	});
}
